const DefaultMapperData = {
  dev: false,
  disable_tooltip: false,
  enable_quickview_carousel: false,
  full_width: false,
  image_overlay: false,
  image_overlay_color: "rgba(0,0,0,0.4)",
  image_url: "",
  is_default: false,
  name: "",
  pins: [],
  slider_id: null
}

export default DefaultMapperData
